import React, { useState } from 'react';
import { Box } from '@mui/material';
import { CustomTab, CustomTabs } from '../components/CustomTabs';
import ThinkBoard from './ThinkBoard';
import { Desdobramento } from '../types/negocio/Desdobramento';
import Tarefas from './Tarefas';

const DesdobramentoPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [guidEdicao, setGuidEdicao] = useState('');
  const [planoAcaoGuid, setPlanoAcaoGuid] = useState('');

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  function onEdit(guid: string): void {
    setGuidEdicao(guid);
    setActiveTab(0);
  }

  function onFinish(desdobramento: Desdobramento): void {
    setPlanoAcaoGuid(desdobramento.planoAcaoGuid);
    setGuidEdicao('');
    setActiveTab(1);
  }

  return (
    <Box sx={{ margin: 'auto' }}>
      <CustomTabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="secondary"
        indicatorColor="secondary"
        variant="fullWidth"
      >
        <CustomTab tabTitle="Tarefas" content={<Tarefas  />} />
        <CustomTab tabTitle="Think Board" content={<ThinkBoard planoAcaoGuid={planoAcaoGuid}/>} />
      </CustomTabs>
    </Box>
  );
};

export default DesdobramentoPage;